import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect } from "react";
import { Outlet, useLocation, useMatch, useNavigate, useParams } from "react-router-dom";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { useAppSelector } from "../store/hooks";
import { selectElectionEventById } from "../store/electionEvents/electionEventsSlice";
import useUpdateTranslation from "../hooks/useUpdateTranslation";
export default function TenantEvent() {
    var navigate = useNavigate();
    var params = useParams();
    var location = useLocation();
    var _a = useContext(SettingsContext), defaultLanguageTouched = _a.defaultLanguageTouched, setDefaultLanguageTouched = _a.setDefaultLanguageTouched;
    var electionEvent = useAppSelector(selectElectionEventById(params.eventId));
    // Own the event translation layer at the persistent route boundary so it
    // survives chooser -> voting-flow child navigation and is cleared only
    // when the event route itself changes or unmounts.
    useUpdateTranslation({ electionEvent: electionEvent }, defaultLanguageTouched, setDefaultLanguageTouched);
    var noMatch = useMatch("/tenant/:tenantId/event/:eventId/");
    var path = "/tenant/".concat(params.tenantId, "/event/").concat(params.eventId, "/election-chooser").concat(location.search);
    useEffect(function () {
        if (noMatch) {
            navigate(path);
        }
    }, [navigate, params, noMatch, path]);
    return _jsx(Outlet, {});
}
